import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../../contexts/Cor";
import DadosUsuarioRedux from "../../../../contexts/Usuario";
import { cadastraListaEmail } from "../../../../services/ModuloGerenciador/Email";
import {
	getUsuarioDependencias
} from "../../../../services/ModuloGerenciador/Geral.ts";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario";
import "./EnviarEmail.css";

function EnviarEmail() {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [dadosUsuarios, setDadosUsuarios] = useState([]);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const navigate = useNavigate();

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
	};

	const names = [
		"Oliver Hansen",
		"Van Henry",
		"April Tucker",
		"Ralph Hubbard",
		"Omar Alexander",
		"Carlos Abbott",
		"Miriam Wagner",
		"Bradley Wilkerson",
		"Virginia Andrews",
		"Kelly Snyder",
	];

	const [personName, setPersonName] = React.useState([]);

	const handleChange = (event) => {
		const {
			target: { value },
		} = event;
		setPersonName(typeof value === "string" ? value.split(",") : value);
		setValues((current) => ({ ...current, destinatarios: personName }));
	};

	const buscarDependencias = async () => {
		setLoading(true);
		await getUsuarioDependencias(dadosUsuarioRedux.token)
			.then((result) => {
				setDadosUsuarios(result.data.usuarios);
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		values.destinatarios = personName;
		setLoading(true);
		await cadastraListaEmail(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					setValues({});
					setPersonName([]);
					setTextoSucesso(result.data);
					setOpenToastSucesso(true);
					setLoading(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
	}, [loading]);

	useEffect(() => {
		buscarDependencias();
	}, []);

	const [semAutorizacao] = useState(false);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<NavbarV3 title="Enviar Email" selecionado="EnviarEmail" />
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					<NavbarV3 title="Enviar Email" selecionado="EnviarEmail" />
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							<div>
								<div className="principal-enviaremail">
									<div className="grid-container">
										<div className="grid-item-start">
											<p className="input-label-emb" htmlFor="descricao">
												Lista Usuários:
											</p>
											<FormControl className="testeform" sx={{ width: 250 }}>
												<Select
													labelId="demo-multiple-checkbox-label"
													id="demo-multiple-checkbox"
													className="select-multiple"
													multiple
													value={personName}
													onChange={handleChange}
													renderValue={(selected) => selected.join(", ")}
													MenuProps={MenuProps}
												>
													{dadosUsuarios.map((user) => (
														<MenuItem key={user.idUsuario} value={user.email}>
															<Checkbox
																checked={personName.indexOf(user.email) > -1}
															/>
															<ListItemText primary={user.usuario} />
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</div>
										<div className="grid-item-start">
											<p className="input-label-emb" htmlFor="descricao">
												Título:
											</p>
											<textarea
												type="text"
												className="input-emb-avisos"
												style={{ width: "100vh" }}
												rows="1"
												onChange={(e) =>
													setValues((current) => ({
														...current,
														assunto: e.target.value,
													}))
												}
												value={values.assunto}
											></textarea>
										</div>
										<div className="grid-item-start">
											<p className="input-label-emb" htmlFor="descricao">
												Mensagem:
											</p>
											<textarea
												type="text"
												className="input-emb-avisos"
												style={{ width: "100vh" }}
												rows="20"
												onChange={(e) =>
													setValues((current) => ({
														...current,
														corpo: e.target.value,
													}))
												}
												value={values.corpo}
											></textarea>
										</div>
									</div>
								</div>
								<div className="botoes-enviaremail">
									<CustomButtonV2
										classCss="custom-button-cancelar"
										classText="button-texto-cancelar"
										titulo="Cancelar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											setValues({});
											navigate("/");
										}}
									/>
									<CustomButtonV2
										classCss="custom-button-cadastrar"
										classText="button-texto-cadastrar"
										icone="iconeSave"
										titulo="Salvar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											cadastrar();
										}}
									/>
								</div>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default EnviarEmail;
